import React from 'react'

import Overlay, { OverlayProps } from '@/components/misc/Overlay'
import { Card, CardContent } from '@/components/ui/card'
import { cn } from '@/lib/utils'

type Props = Pick<OverlayProps, 'fullScreen' | 'variant'> & {
  children: React.ReactNode
  centered?: boolean
  className?: string
}

const OverlayCard: React.FC<Props> = ({
  children,
  centered,
  className,
  fullScreen,
  variant,
}) => (
  <Overlay variant={variant} fullScreen={fullScreen} contentCentered={centered}>
    <Card className={cn('mx-auto max-w-175 bg-white', className)}>
      <CardContent>{children}</CardContent>
    </Card>
  </Overlay>
)

export default OverlayCard
